import { ServerClient } from 'common/utils/http/http-clients';

class MassService {
  async sendWelcomeEmails() {
    const res = await ServerClient.put<void>(`/mass/welcome-email`);
    return res?.data;
  }

  async sendWelcomeEmailsToUnregistered() {
    const res = await ServerClient.put<void>(`/mass/unregistered/welcome-email`);
    return res?.data;
  }
}

export const massService = new MassService();
export default massService;
